import React from 'react';
import { Card, Col, Checkbox, Radio, Popover } from 'antd';
import FileConstants from '../../../../FileConstants';
import { useState, useEffect } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';

const Model3DSelection = (props) => {

    const [modelTypes, setModelTypes] = useState(props.modelTypes);
    const [radioModelType, setRadioModelType] = useState({
        photography_3d: 'high_pbr',
        configurator: 'high_pbr_segmented'
    });
    const [triggerChange, setTriggerChange] = useState(false);


    const changeModelOutput = (checkedValues) => {
        // Set checkbox values in tempModelTypes
        let tempModelTypes = [...checkedValues];  // Copy of the selected checkboxes
        setModelTypes(tempModelTypes);
        // Handle radio button selections based on the selected checkboxes
        const updatedModelTypes = [];

        // Loop through selected checkboxes and add them to the final model types
        tempModelTypes.forEach((checkbox) => {

            if (checkbox === 'photography_3d') {
                updatedModelTypes.push(radioModelType.photography_3d);
            } else if (checkbox === 'configurator' && radioModelType.configurator) {
                updatedModelTypes.push(radioModelType.configurator);
            } else {
                updatedModelTypes.push(checkbox);
            }

        });

        const uniqueModelTypes = [...new Set(updatedModelTypes)];

        // Update the state with the new model types
        props.changeModelOutput(uniqueModelTypes);
    };


    const changeRadioGroup = (e, checkboxType) => {
        const selectedRadio = e.target.value;
        setRadioModelType(prevState => ({
            ...prevState,
            [checkboxType]: selectedRadio
        }));
        setTriggerChange(true);
    };

    useEffect(() => {
        if (triggerChange) {
            let tempModelTypes = [...modelTypes];
            const updatedModelTypes = tempModelTypes.map((checkbox) => {
                if (checkbox === 'photography_3d') return radioModelType.photography_3d;
                if (checkbox === 'configurator') return radioModelType.configurator;
                return checkbox;
            });

            const uniqueModelTypes = [...new Set(updatedModelTypes)];
            props.changeModelOutput(uniqueModelTypes);
            setTriggerChange(false);
        }
    }, [triggerChange]);


    useEffect(() => {
        if (props.modelTypeHasSet == true && props.modelTypeMapping != null) {
            setModelTypes(props.modelTypeMapping.model_type);
            if (props.modelTypeMapping?.radio_button) {
                setRadioModelType(props.modelTypeMapping.radio_button);
            }
            props.setModelTypeHasSet(false);
            setTriggerChange(true);
        }
    }, [props.modelTypeHasSet, props.modelTypeMapping])


    return (
        <Col span={24}>
            <div className='justify-space-between' style={{ marginBottom: 8, marginTop: 10, paddingRight: 8 }}>
                <h1
                    className="manrope f-14 lh-22 w-700 black-085 mb-0">{props.creation_type == 'material'? 'What is the type of Material you need?' :'What will you be using your 3D models for?'}</h1>
                <p className='manrope f-12 w-400 black-55 mb-0'
                >Select all that apply</p>
            </div>

            <Checkbox.Group onChange={changeModelOutput}
                value={modelTypes} className='justify-space-start wrap'
                style={{ marginBottom: 10 }}>
                {FileConstants.modelTypes_2.map((output) => (
                    <Card className='model-output-card without-border' bordered={false}>
                        <img className='image-radius mb-24' src={output.image} />
                        {!output.name.includes('Configurator') ?
                            <Checkbox value={output.type} className='model-3d blue-checkbox justify-in-start'>
                                <span className='manrope f-14 black-085 lh-22 w-400'>{output.name}</span>
                                <span>
                                    <Popover trigger="hover" className="manrope f-14 black-55 centered-popup"
                                        placement="bottom"
                                        overlayClassName="tips-popover" content={
                                            <div>
                                                <div className="justify-space-between">
                                                    {output.supported_usecases.map((usecase, index) => (
                                                        <img src={usecase.icon} className={output.supported_usecases.length == index ? "" : "mr-8"} />
                                                    ))}
                                                </div>
                                            </div>}
                                    >
                                        <InfoCircleOutlined className='manrope f-14 blue ml-4' />
                                    </Popover>

                                </span>
                            </Checkbox> :
                            output.supported_usecases.map((use) => (
                                <>
                                    <Checkbox value={use.type} className='model-3d blue-checkbox justify-in-start'>
                                        <span className='manrope f-14 black-085 lh-22 w-400'>{use.name}</span>
                                        <span>
                                            {/* <InfoCircleOutlined className='manrope f-14 blue ml-4' /> */}
                                        </span>
                                    </Checkbox>
                                    {modelTypes.includes('configurator') && use?.materials?.length > 0 &&
                                        <>
                                            <div className='manrope f-14 w-700 black-085 lh-22 mb-8'>Select rendering type</div>
                                            <Col span={24}>
                                                <Radio.Group
                                                    value={radioModelType[use.type]}
                                                    onChange={(e) => changeRadioGroup(e, use.type)}
                                                    className={`flex-imp justify-align-start model-output-radio`} style={{ marginBottom: 10, flexWrap: "unset" }} >
                                                    {use?.materials?.map((material, index) => (
                                                        <Radio value={material.type} style={{ whiteSpace: "break-spaces" }}>
                                                            <span className='manrope f-14 w-400 lh-22 black-085'>{material.name}</span>
                                                            {material.secondary && <span className='manrope f-14 w-400 lh-22 grey-77 ml-4'>{material.secondary}</span>}
                                                        </Radio>
                                                    ))}
                                                </Radio.Group>
                                            </Col>
                                        </>}
                                </>
                            ))}
                        {modelTypes.includes('photography_3d') && output?.materials?.length > 0 &&
                            <>
                                <div className='manrope f-14 w-700 black-085 lh-22 mb-8'>Select rendering type </div>
                                <Col span={24}>
                                    <Radio.Group value={radioModelType[output.type]}
                                        onChange={(e) => changeRadioGroup(e, output.type)}
                                        className={`flex-imp justify-align-start model-output-radio`}
                                        style={{ marginBottom: 10, flexWrap: "unset" }} >
                                        {output?.materials?.map((material, index) => (
                                            <Radio value={material.type} style={{ whiteSpace: "break-spaces" }}>
                                                <span className='manrope f-14 w-400 lh-22 black-085'>{material.name}</span>
                                                {material.secondary && <span className='manrope f-14 w-400 lh-22 grey-77 ml-4'>{material.secondary}</span>}
                                            </Radio>
                                        ))}
                                    </Radio.Group>
                                </Col>
                            </>}
                    </Card>
                ))}
            </Checkbox.Group>
        </Col>);
}

export default Model3DSelection;
